import React from "react";
import {Button, Col, Form, Input, Row} from "antd";
import BaseComponent from "../../redare/components/BaseComponent";
import ImageCode from "./ImageCode";

export default class VerificationForm extends BaseComponent {

    state = {
        url: ""
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.setState({ url: 'https://ssyerv1.oss-cn-hangzhou.aliyuncs.com/picture/76d476e8c375465aa1b3e0e22a20aa41.jpg' })
    }

    onReload = () => {
        this.setState({ url: 'https://ssyerv1.oss-cn-hangzhou.aliyuncs.com/picture/76d476e8c375465aa1b3e0e22a20aa41.jpg' })
    }


    render() {
        return (
            <div>
                <ImageCode
                    imageUrl={this.state.url}
                    onReload={this.onReload}
                    onMatch={() => {
                        setTimeout(() => {
                            this.props.onCodeSuccess()
                        }, 1000);
                        this.props.onSMSVCode();
                    }}
                />
            </div>
        )
    }

}